import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [roles, setRoles] = useState([]);
  const [userFullName, setUserFullName] = useState('');

  return (
    <UserContext.Provider value={{ roles, setRoles, userFullName, setUserFullName }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
